import { RootState } from "../store/store";

// common selectors
export const selectLoader = (state: RootState) => state.common.loader;
export const usersList = (state: RootState) => state.common.usersList;
export const labelsList = (state: RootState) => state.common.labelsList;
export const SubcontractorsListForTimelineTask = (state: RootState) => state.common.subsList;
export const addLabelData = (state: RootState) => state.common.addLabelData;
export const commonError = (state: RootState) => state.common.error;
export const snackbarObj = (state: RootState) => state.common.snackbarObj;